export const FILTER_NAME = 'lot-sheets'
